import { render, staticRenderFns } from "./TgLayout.vue?vue&type=template&id=0b2fbd07"
import script from "./TgLayout.vue?vue&type=script&lang=js"
export * from "./TgLayout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports